<template>
  <!-- 文化讲堂 -->
  <div id="Culturelec">
    <li v-for="(item,index) in CulturelecList" :key="index" :class="{CulturelecNav:CulturelecNav===index}" @click="CulturelecNav=index">
			<!-- <div class="periodiCon_cluster_Cont_img">
				<img :src="item.TitlePhoto" alt="">
			</div> -->
			<div class="periodiCon_cluster_Cont_right">
        <p><router-link :to="{name:'Culturelecdetail',query: {id: item.ContentID}}" v-html="item.Title"></router-link></p>
        <p>{{item.Abstruct}}</p>
				<p>
					<span>{{item.AddDate}}</span>
					<span><router-link :to="{name:'Culturelecdetail',query: {id: item.ContentID}}">MORE</router-link></span>
				</p>
			</div>
			<div style="clear:both;"></div>
		</li>
		<el-pagination background class="r" @size-change="handleSizeChange" @current-change="handleCurrentPageChange" :current-page="page.currentPage" :page-sizes="page.sizes" :page-size="page.pageSize" layout="total, sizes, prev, pager, next, jumper" :total="page.total"></el-pagination>
  </div>
</template>

<script>
import axios from 'axios'
import { pagination } from '../../../../src/assets/mixin/data-table'
export default {
	name:'Culturelec',
	mixins: [pagination],
  data(){
    return{
      Lmurl:'http://cmcpa.boyuancb.com',
			CulturelecNav:'',
			CulturelecList:[],
    }
  },
  components:{

  },
  methods:{
		getInfo(){
      this.page.currentPage = 1;
      this.getTableData();
    },
    getTableData(){
			axios.post('/SiteContentAPI/GetPageList',
			{
				ChannelID:2852,
				JournalID:202007100001,
				CurrentPage:this.page.currentPage,
				PageSize:this.page.pageSize
			}).then((res) => {
				this.CulturelecList = res.data._itemList//党建学习
				this.page.total = res.data.totalRecords
				this.CulturelecList.forEach((item) => {
					item.AddDate = item.AddDate.substr(0,10)
					item.TitlePhoto = this.Lmurl + item.TitlePhoto
				})
			})
		},
		handleCurrentPageChange(val){
      this.page.currentPage = val;
      this.getTableData();
    },
  },
  created(){
    this.getInfo();
  }
}
</script>

<style lang="less" scoped>
  #Culturelec{
		width:100%;
		height:auto;
		margin: 0 auto;
		position: relative;
		margin-bottom:25px;
		.CulturelecNav{
			background:#F7F8FA;
			.periodiCon_cluster_Cont_right{
				p:nth-child(1){
					a{
						color:#C01B22;
					}
				}
			}
		}
		li:hover{
			background:#F7F8FA;
			.periodiCon_cluster_Cont_right{
				p:nth-child(1){
					a{
						color:#C01B22;
					}
				}
			}
		}
		li{
			list-style: none;
			width: 100%;
			height: auto;
			// float: left;
			margin-right: 44px;
			cursor: pointer;
			padding:15px 9px;
			background:#fff;
			border-bottom:1px solid #E6E6E6;
			.periodiCon_cluster_Cont_img{
				width: 175px;
				height: 120px;
				float: left;
				img{
					width: 100%;
					height: 100%;
				}
			}
			.periodiCon_cluster_Cont_right{
				width:100%;
				float: right;
				p:nth-child(1){
					width: 100%;
					overflow: hidden;
					text-overflow: ellipsis;
					display: -webkit-box;
					-webkit-line-clamp: 1;
					line-clamp: 1;
          -webkit-box-orient: vertical;
					a{
						color: #333333;
						font-size: 18px;
					}
				}
				p:nth-child(2){
					width: 100%;
					overflow: hidden;
					text-overflow: ellipsis;
					display: -webkit-box;
					-webkit-line-clamp: 3;
					line-clamp: 3;
					/*! autoprefixer: off */
          -webkit-box-orient: vertical;
          /* autoprefixer: on */
					color: #8B8B8B;
					font-size:14px;
					margin-top:7px;
          text-align:justify;
          // text-indent: 2em;
				}
				p:nth-child(3){
					width: 100%;
					height: 15px;
					margin-top: 9px;
					span:nth-child(1){
						color:#909090;
						font-size: 14px;
						float: left;
					}
					span:nth-child(2) a{
						color: #909090;
						font-size: 16px;
						float: right;
					}
				}
			}
		}
	}
	/deep/.content_body_left_divC{
		margin-top: 0!important;
	}
	/deep/.el-pagination{
    position: absolute;
    bottom: -46px;
    width: 100%;
    text-align: center;
  }
</style>



// WEBPACK FOOTER //
// src/components/Associvoice/Culturelec/index.vue